import { render, staticRenderFns } from "./m-guest-check-in-template-gallery.vue?vue&type=template&id=674c4e48&scoped=true&"
import script from "./m-guest-check-in-template-gallery.vue?vue&type=script&lang=js&"
export * from "./m-guest-check-in-template-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c4e48",
  null
  
)

export default component.exports